import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { uniformeModulo } from 'src/app/aplicaciones-modulos/spyral/diccionarios/uniformeModule';

@Injectable({
  providedIn: 'root'
})
export class CaracteristicaService {

  diccionarioUrl: any;
  urlUniforme: string;
  
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlUniforme = this.utilServices.getUniforme();
    this.diccionarioUrl = uniformeModulo.url.uniforme;
  }

  getAllDepartamento() {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.caracteristica + '/departamento');
  } 

  getAllLocalidad() {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.caracteristica + '/localidad' );
  } 

  getAllEmpleado() {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.empleado);
  } 

  findEmpleadoByLocalidad(localidad: string) {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.empleado + 'localidad' + '/' + localidad);
  } 
  
  findEmpleadoByDepartamento(departamento: string) {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.empleado + 'departamento' + '/' + departamento);
  } 

  findEmpleadoByDepLoc(departamento: string, localidad: string) {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.empleado + 'depaLocalidad' 
        + '/' + departamento +'/'+ localidad);
  } 

  sincroDa(area: string, localidad: string, empleado: string){
    return this.commom.peticionPostConHeader(this.urlUniforme + this.diccionarioUrl.sincronizar.da + '/' + area 
        + '/' + localidad +'/'+ empleado, null);
  }
  
  getSyncStatus() {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.syncStatus);
  } 

}